import { FC } from 'react';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import SubMenuMobile from '../subMenu/SubMenuMobile';
import PromotionMenuMobile from './PromotionMenuMobile';
const PromotionMenuMobileLogic: FC = () => {
  const {
    setIsMenuMobileOpen,
    isPromotionMenuMobileOpen,
    setIsPromotionMenuMobileOpen
  } = headerStore(state => state);
  const onCloseMenu = () => {
    setIsMenuMobileOpen(false);
    setIsPromotionMenuMobileOpen(false);
  };
  return <SubMenuMobile title="โปรโมชัน" content={<PromotionMenuMobile onCloseMenu={onCloseMenu} />} isSubMenuMobileOpen={isPromotionMenuMobileOpen} setIsSubMenuMobileOpen={setIsPromotionMenuMobileOpen} onCloseMenu={onCloseMenu} />;
};
export default PromotionMenuMobileLogic;